import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getSortedTableData } from 'components/datatable/TableUtils'
import { getStationsHash } from 'utils/StationUtils'
import SieauAction from 'components/sieau/SieauAction'
import { isObject } from 'lodash'
import { nbPerPageLabel } from 'referencial/constants/ReferencialConstants'
import { push } from '@lagunovsky/redux-react-router'
import { CardTable } from 'components/datatable/NewTable'
import i18n from 'simple-react-i18n'
import { exportFile } from 'utils/ExportDataUtil'

const DashboardStationsPanel = ({
    stationType,
    data = [],
    headers = [],
    exportTableHeaders = [],
}) => {
    const dispatch = useDispatch()

    const {
        selectedSearchValues,
    } = useSelector(store => ({
        selectedSearchValues: store.AdministrationReducer.selectedSearchValues,
    }), shallowEqual)

    const [columnName, setColumnName] = useState()
    const [sort, setSort] = useState()

    const searchValues = selectedSearchValues[stationType]
    const initialSort = (searchValues && searchValues.columnName) && { column: searchValues.columnName, sort: searchValues.sort }

    const setSelectedSearchValueStations = useCallback(() => {
        const sortedStations = getSortedTableData(data.stations, { column: columnName, sort }, false)
        if (!searchValues || !searchValues.stations || getStationsHash(searchValues.stations) !== getStationsHash(sortedStations)) {
            dispatch(SieauAction.update('selectedSearchValues', stationType, { stations: sortedStations, columnName, sort }))
        }
    }, [columnName, data.stations, dispatch, searchValues, sort, stationType])

    useEffect(() => {
        setSelectedSearchValueStations()
    }, [sort, data, stationType, setSelectedSearchValueStations])

    const getColor = station => {
        if (station.color) return station.color
        if (isObject(station.closeDate)) {
            return station?.closeDate?.value ? 'grey' : 'white'
        }
        return station.closeDate ? 'grey' : 'white'
    }

    const exportAction = exportTableHeaders.length ? {
        icon: 'file_download',
        tooltip: i18n.export,
        onClick: () => {
            const exportData = data.stations?.length ? [{ ...data.stations[0], headers: exportTableHeaders }, ...data.stations.slice(1)] : []
            exportFile({
                data: exportData,
                exportType: 'xlsx',
                titleFile: data.title,
            })
        },
    }: {}

    const actions = data.legendPanel ? [{
        icon: 'info_outlined',
        tooltip: data.legendPanel,
    }, exportAction] : [exportAction]

    return (
        <CardTable
            title={data.title}
            rows={data.stations.map(station => ({ ...station, colorLine: getColor(station) }))}
            headers={headers}
            defaultSort={initialSort}
            actions={actions}
            rowsPerPageOptions={nbPerPageLabel}
            onSort={(newColumnName, newSort) => {
                setColumnName(newColumnName)
                setSort(newSort)
            }}
            onClickRow={s => dispatch(push(`/station/${stationType}/${s.id}`))}
            data-cy={stationType}
        />
    )
}

DashboardStationsPanel.propTypes = {
    stationType: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    headers: PropTypes.arrayOf(PropTypes.string),
    exportTableHeaders: PropTypes.arrayOf(PropTypes.string),
}

export default DashboardStationsPanel